export const AUDIT_RULE_CATEGORY_LABELS = {
  kardex: 'Kardex y traspasos',
  inventory: 'Toma de inventario',
};

export function auditRuleLabel(code, fallback = code) {
  const labels = {
    salida_costo_incorrecto: 'Costo salida incorrecto',
    linea_total_inconsistente: 'Línea total inconsistente',
    stock_negativo: 'Stock negativo',
    valor_negativo: 'Valor negativo',
    salida_vaciado_stock: 'Stock cero con valor residual',
    recepcion_costo_traspaso: 'Recepción vs traspaso',
    recepcion_excede_pendiente: 'Recepción excede pendiente',
    traspaso_incompleto: 'Traspaso incompleto',
    traspaso_sin_recepcion: 'Traspaso sin recepción',
    inventario_meta_pendiente: 'Meta de inventario pendiente',
    inventario_vencido: 'Campaña vencida',
    inventario_producto_pendiente_compra: 'Producto pendiente (compra)',
    inventario_rotacion_vencida: 'Rotación de inventario vencida',
  };
  return labels[code] || fallback;
}
